/* eslint-disable @admin-tribe/admin-tribe/angular-component-controller-naming, angular/controller-as-route, sort-keys */
(function () {
  angular.module('app.main').config(routeConfig);

  /* @ngInject */
  function routeConfig(
    $locationProvider,
    $stateProvider,
    $urlRouterProvider,
    RC_USER_ROLES,
    RcUserRolesProvider,
    STORAGE_AVAILABLE
  ) {
    $locationProvider.html5Mode(true).hashPrefix('!');

    // Template provider function for customer segments in the context of both team members and license admins
    const customerSegmentsTemplateProvider = (
      $http,
      $templateCache,
      $stateParams,
      CustomerSegments
    ) => {
      const segment = CustomerSegments.getCurrentSegment($stateParams);
      const url = `views/partials/customer-segments/${segment.path}.html`;
      return $http.get(url, {cache: $templateCache}).then((response) => response.data);
    };

    // States
    if (STORAGE_AVAILABLE) {
      $stateProvider
        .state('root', {
          url: '/',
          templateUrl: 'views/root.html',
          data: {
            access: RcUserRolesProvider.getWildcardAccessLevel(),
            hideHeader: true,
            hideFooter: true,
          },
        })
        .state('login', {
          url: '/login',
          controller: 'LoginController',
          templateUrl: 'views/login.html',
          data: {
            access: RcUserRolesProvider.getWildcardAccessLevel(),
            headTitle: 'login.title',
          },
        })
        .state('logout', {
          url: '/logout',
          controller: 'LogoutController',
          templateUrl: 'views/logout.html',
          data: {
            access: RcUserRolesProvider.getWildcardAccessLevel(),
          },
        })
        .state('invitation', {
          url: '/invitation/:invitationCode?locale',
          data: {
            access: RcUserRolesProvider.getAccessLevel(RC_USER_ROLES.ANONYMOUS),
            preventAutoLogin: true,
          },
        })
        .state('dashboard', {
          url: '/dashboard',
          controller: 'DashboardController',
          templateUrl: 'views/dashboard.html',
          data: {
            access: RcUserRolesProvider.getAccessLevel(RC_USER_ROLES.RESELLER_TEAM_ADMIN),
            headTitle: 'dashboard.title',
          },
        })
        .state('organizationDetails', {
          url: '/organization-details',
          controller: 'OrganizationDetailsController',
          templateUrl: 'views/organization-details.html',
          data: {
            access: RcUserRolesProvider.getAccessLevel(RC_USER_ROLES.RESELLER_TEAM_ADMIN),
            headTitle: 'organizationDetails.title',
            breadcrumbsMenu: [{label: 'organizationDetails.title'}],
          },
        })
        .state('teamMembers', {
          url: '/team',
          controller: 'TeamMembersController',
          templateUrl: 'views/team-members.html',
          data: {
            access: RcUserRolesProvider.getAccessLevel(RC_USER_ROLES.RESELLER_TEAM_ADMIN),
            headTitle: 'teamMembers.title',
            breadcrumbsMenu: [{label: 'teamMembers.title'}],
          },
        })
        .state('customers', {
          abstract: true,
          url: '/customers',
          controller: 'CustomersController',
          templateUrl: 'views/customers.html',
          data: {
            access: RcUserRolesProvider.getAccessLevel(
              RC_USER_ROLES.RESELLER_TEAM_MEMBER,
              RC_USER_ROLES.RESELLER_TEAM_ADMIN
            ),
            headTitle: 'customersList.title',
            breadcrumbsMenu: [{label: 'customersList.title'}],
          },
        })
        .state('customers.defaultSegment', {
          url: '', // Extra empty-URL state only to allow access to /customers without segment name or trailing slash
          templateProvider: customerSegmentsTemplateProvider,
        })
        .state('customers.segments', {
          url: '/:segment',
          templateProvider: customerSegmentsTemplateProvider,
        })
        .state('customerDetails', {
          url: '/customer-details/:customerID',
          controller: 'CustomerDetailsController',
          templateUrl: 'views/customer-details.html',
          data: {
            access: RcUserRolesProvider.getAccessLevel(
              RC_USER_ROLES.RESELLER_TEAM_MEMBER,
              RC_USER_ROLES.RESELLER_TEAM_ADMIN
            ),
            headTitle: 'customerDetails.title',
            breadcrumbsMenu: [
              {label: 'customersList.title', stateName: 'customers.segments'},
              {label: 'customerDetails.title'},
            ],
          },
        })
        .state('licenseAdmin', {
          abstract: true,
          url: '/license-admin',
          controller: 'LicenseAdminController',
          templateUrl: 'views/default-abstract-state.html', // Abstract states still need a ui-view for its children to populate
          data: {
            access: RcUserRolesProvider.getAccessLevel(
              RC_USER_ROLES.LICENSE_ADMIN_READ_ONLY,
              RC_USER_ROLES.LICENSE_ADMIN_READ_WRITE,
              RC_USER_ROLES.LICENSE_ADMIN_READ_WRITE_REFRESH_CUSTOMER
            ),
            headTitle: 'customersList.title',
          },
        })
        .state('licenseAdmin.search', {
          url: '/search',
          controller: 'LicenseAdminSearchController',
          templateUrl: 'views/license-admin-search.html',
          data: {
            headTitle: 'licenseAdminSearch.title',
            breadcrumbsMenu: [{label: 'licenseAdminSearch.title'}],
          },
        })
        .state('licenseAdmin.inviteReseller', {
          url: '/invite-reseller-organization',
          controller: 'LicenseAdminInviteResellerController',
          templateUrl: 'views/license-admin-invite-reseller.html',
          data: {
            access: RcUserRolesProvider.getAccessLevel(
              RC_USER_ROLES.LICENSE_ADMIN_READ_WRITE,
              RC_USER_ROLES.LICENSE_ADMIN_READ_WRITE_REFRESH_CUSTOMER
            ),
            headTitle: 'licenseAdminCreateReseller.title',
            breadcrumbsMenu: [{label: 'licenseAdminCreateReseller.title'}],
          },
        })
        .state('licenseAdmin.bulkChangeResellerOrganization', {
          url: '/bulk-change-reseller-organization',
          controller: 'LicenseAdminBulkChangeResellerController',
          controllerAs: 'vm',
          templateUrl: 'views/license-admin-bulk-change-reseller.html',
          data: {
            access: RcUserRolesProvider.getAccessLevel(
              RC_USER_ROLES.LICENSE_ADMIN_READ_WRITE,
              RC_USER_ROLES.LICENSE_ADMIN_READ_WRITE_REFRESH_CUSTOMER
            ),
            headTitle: 'licenseAdminBulkChangeReseller.title',
            breadcrumbsMenu: [{label: 'licenseAdminBulkChangeReseller.title'}],
          },
        })
        .state('licenseAdmin.bulkInviteResellerOrganization', {
          url: '/bulk-invite-reseller-organization',
          controller: 'LicenseAdminBulkInviteResellerController',
          controllerAs: 'vm',
          templateUrl: 'views/license-admin-bulk-invite-reseller.html',
          data: {
            access: RcUserRolesProvider.getAccessLevel(
              RC_USER_ROLES.LICENSE_ADMIN_READ_WRITE,
              RC_USER_ROLES.LICENSE_ADMIN_READ_WRITE_REFRESH_CUSTOMER
            ),
            headTitle: 'licenseAdminBulkInviteReseller.title',
            breadcrumbsMenu: [{label: 'licenseAdminBulkInviteReseller.title'}],
          },
        })
        .state('licenseAdmin.manageAdmins', {
          url: '/manage-admins',
          controller: 'ManageLicensingAdminsController',
          templateUrl: 'views/manage-licensing-admins.html',
          data: {
            access: RcUserRolesProvider.getAccessLevel(
              RC_USER_ROLES.LICENSE_ADMIN_READ_WRITE,
              RC_USER_ROLES.LICENSE_ADMIN_READ_WRITE_REFRESH_CUSTOMER
            ),
            headTitle: 'manageLicensingAdmins.title',
            breadcrumbsMenu: [
              {label: 'licenseAdminSearch.title', stateName: 'licenseAdmin.search'},
              {label: 'manageLicensingAdmins.title'},
            ],
          },
        })
        .state('licenseAdmin.impersonatedReseller', {
          abstract: true,
          url: '/:resellerID',
          resolve: {
            /* @ngInject */
            impersonatedReseller($stateParams, Reseller) {
              return Reseller.get($stateParams.resellerID);
            },
          },
          controller: 'ResellerImpersonatorController',
          templateUrl: 'views/default-abstract-state.html',
        })
        .state('licenseAdmin.impersonatedReseller.dashboard', {
          url: '/dashboard',
          controller: 'DashboardController',
          templateUrl: 'views/dashboard.html',
          data: {
            access: RcUserRolesProvider.getAccessLevel(
              RC_USER_ROLES.LICENSE_ADMIN_READ_ONLY,
              RC_USER_ROLES.LICENSE_ADMIN_READ_WRITE,
              RC_USER_ROLES.LICENSE_ADMIN_READ_WRITE_REFRESH_CUSTOMER
            ),
            headTitle: 'dashboard.title',
          },
        })
        .state('licenseAdmin.impersonatedReseller.organizationDetails', {
          url: '/organization-details',
          controller: 'OrganizationDetailsController',
          templateUrl: 'views/organization-details.html',
          data: {
            access: RcUserRolesProvider.getAccessLevel(
              RC_USER_ROLES.LICENSE_ADMIN_READ_ONLY,
              RC_USER_ROLES.LICENSE_ADMIN_READ_WRITE,
              RC_USER_ROLES.LICENSE_ADMIN_READ_WRITE_REFRESH_CUSTOMER
            ),
            headTitle: 'organizationDetails.title',
            breadcrumbsMenu: [{label: 'organizationDetails.title'}],
          },
        })
        .state('licenseAdmin.impersonatedReseller.teamMembers', {
          url: '/team',
          controller: 'TeamMembersController',
          templateUrl: 'views/team-members.html',
          data: {
            access: RcUserRolesProvider.getAccessLevel(
              RC_USER_ROLES.LICENSE_ADMIN_READ_ONLY,
              RC_USER_ROLES.LICENSE_ADMIN_READ_WRITE,
              RC_USER_ROLES.LICENSE_ADMIN_READ_WRITE_REFRESH_CUSTOMER
            ),
            headTitle: 'teamMembers.title',
            breadcrumbsMenu: [{label: 'teamMembers.title'}],
          },
        })
        .state('licenseAdmin.impersonatedReseller.customers', {
          abstract: true,
          url: '/customers',
          controller: 'CustomersController',
          templateUrl: 'views/customers.html',
          data: {
            access: RcUserRolesProvider.getAccessLevel(
              RC_USER_ROLES.LICENSE_ADMIN_READ_ONLY,
              RC_USER_ROLES.LICENSE_ADMIN_READ_WRITE,
              RC_USER_ROLES.LICENSE_ADMIN_READ_WRITE_REFRESH_CUSTOMER
            ),
            headTitle: 'customersList.title',
            breadcrumbsMenu: [{label: 'customersList.title'}],
          },
        })
        .state('licenseAdmin.impersonatedReseller.customers.defaultSegment', {
          url: '', // Extra empty-URL state only to allow access to /customers without segment name or trailing slash
          templateProvider: customerSegmentsTemplateProvider,
        })
        .state('licenseAdmin.impersonatedReseller.customers.segments', {
          url: '/:segment',
          templateProvider: customerSegmentsTemplateProvider,
        })
        .state('licenseAdmin.impersonatedReseller.customerDetails', {
          url: '/customer-details/:customerID',
          controller: 'CustomerDetailsController',
          templateUrl: 'views/customer-details.html',
          data: {
            access: RcUserRolesProvider.getAccessLevel(
              RC_USER_ROLES.LICENSE_ADMIN_READ_ONLY,
              RC_USER_ROLES.LICENSE_ADMIN_READ_WRITE,
              RC_USER_ROLES.LICENSE_ADMIN_READ_WRITE_REFRESH_CUSTOMER
            ),
            headTitle: 'customerDetails.title',
            breadcrumbsMenu: [
              {
                label: 'customersList.title',
                stateName: 'licenseAdmin.impersonatedReseller.customers.segments',
              },
              {label: 'customerDetails.title'},
            ],
          },
        })
        .state('licenseAdmin.impersonatedReseller.changeReseller', {
          url: '/change-reseller/:customerID',
          controller: 'ChangeCustomerResellerController',
          templateUrl: 'views/change-customer-reseller.html',
          data: {
            access: RcUserRolesProvider.getAccessLevel(
              RC_USER_ROLES.LICENSE_ADMIN_READ_WRITE,
              RC_USER_ROLES.LICENSE_ADMIN_READ_WRITE_REFRESH_CUSTOMER
            ),
            headTitle: 'changeCustomerReseller.title',
            breadcrumbsMenu: [
              {
                label: 'customersList.title',
                stateName: 'licenseAdmin.impersonatedReseller.customers.segments',
              },
              {
                label: 'customerDetails.title',
                stateName: 'licenseAdmin.impersonatedReseller.customerDetails',
              },
              {label: 'changeCustomerReseller.title'},
            ],
          },
        })
        .state('licenseAdmin.impersonatedReseller.extendRenewalWindow', {
          url: '/extend-renewal-window/:customerID',
          controller: 'ExtendCustomerRenewalWindowController',
          templateUrl: 'views/extend-renewal-window.html',
          data: {
            access: RcUserRolesProvider.getAccessLevel(
              RC_USER_ROLES.LICENSE_ADMIN_READ_WRITE,
              RC_USER_ROLES.LICENSE_ADMIN_READ_WRITE_REFRESH_CUSTOMER
            ),
            headTitle: 'extendRenewalWindow.title',
            breadcrumbsMenu: [
              {
                label: 'customersList.title',
                stateName: 'licenseAdmin.impersonatedReseller.customers.segments',
              },
              {
                label: 'customerDetails.title',
                stateName: 'licenseAdmin.impersonatedReseller.customerDetails',
              },
              {label: 'extendRenewalWindow.title'},
            ],
          },
        })
        .state('demoMode', {
          url: '/demo',
          controller: 'DemoModeController',
          templateUrl: 'views/demo-mode.html',
          data: {
            access: RcUserRolesProvider.getAccessLevel(RC_USER_ROLES.ANONYMOUS),
            preventAutoLogin: true,
            headTitle: 'demoMode.title',
          },
        });
    } else {
      $stateProvider
        .state('root', {
          url: '/',
          templateUrl: 'views/root.html',
          data: {
            access: RcUserRolesProvider.getWildcardAccessLevel(),
            hideHeader: true,
            hideFooter: true,
          },
        })
        .state('cookiesDisabled', {
          url: '/cookies-disabled',
          controller: 'CookiesDisabledController',
          data: {
            access: RcUserRolesProvider.getWildcardAccessLevel(),
            preventAutoLogin: true,
          },
        });
    }

    // Redirect unmatched URLs to root
    $urlRouterProvider.otherwise(($injector) => {
      const appReady = $injector.get('appReady');
      appReady
        .whenRunReady()
        .then(() => {
          const $state = $injector.get('$state');
          $state.go('root');
        })
        .catch((error) => {
          const $log = $injector.get('$log');
          $log.info('Failed to load the application', error);
        });
    });
  }
})();
/* eslint-enable @admin-tribe/admin-tribe/angular-component-controller-naming, angular/controller-as-route, sort-keys */
